import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index";
const CHANGE_PAGE = "CHANGE_PAGE"; //ES2015 风格

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    path: "/homePage", //页面路径
    id: 0,
    paramsID: "",
    videoObject: "",
    point: "",
    WebLoginuser:"",
    userinfo_tab:'0'
  },
  mutations: {
    [CHANGE_PAGE](state, payload) {
      state.path = payload;
      state.id = router.options.routes.filter((item) => {
        return item.path == payload && item.meta;
      })[0].meta.id;
    },
    // 父传子，传id
    ParamsId(state, payload) {
      state.paramsID = payload;
    },
    // 优邦体验，视频对象信息
    CHANGE_VIDEO(state, payload) {
      state.videoObject = payload;
    },
  },
  actions: {},
  modules: {},
});
